import { render, staticRenderFns } from "./TextCarousel.vue?vue&type=template&id=b3a2272e&scoped=true"
import script from "./TextCarousel.vue?vue&type=script&lang=ts"
export * from "./TextCarousel.vue?vue&type=script&lang=ts"
import style0 from "./TextCarousel.vue?vue&type=style&index=0&id=b3a2272e&prod&lang=scss"
import style1 from "./TextCarousel.vue?vue&type=style&index=1&id=b3a2272e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a2272e",
  null
  
)

export default component.exports